export default "__VITE_ASSET__gyh_TLoj__"